import { IFilterInfo } from 'redux/reducers/usage/filter/filter';
import { IHasId } from './addLabel';

export type IHasIsRecent = {
  isRecent: boolean;
  isEx?: boolean;
} & IHasId;

type TAddRecentResult = (item: IHasId) => IHasIsRecent;

export default function addRecent(recentFilters: any): TAddRecentResult {
  if (!recentFilters) {
    throw new Error(
      'Illegal argument: addRecent received NULL for its recentFilters parameter.'
    );
  }
  return (item: IHasId): IHasIsRecent => {
    if (!item) {
      throw new Error(
        'Illegal argument: addRecent received NULL for its item parameter.'
      );
    }
    (item as IHasIsRecent).isRecent = recentFilters.some(
      (filter: IFilterInfo): boolean => filter.filterValue === item.id
    );
    return item as IHasIsRecent;
  };
}
